import styled from 'styled-components'
import { mobileBreakpoint, tabletBreakpoint } from 'react-components'
import CloseIcon from '../../../assets/icons/close.svg'

export const GalleryWrapper = styled.div`
    width: 100%;
    aspect-ratio: 4 / 3;
    @media only screen and (min-width: ${tabletBreakpoint.min}px) {
        aspect-ratio: unset;
    }
`

export const ThumnailImageWrapper = styled.div<{ isActive: boolean }>`
    display: flex;
    flex: 1;
    width: 6.5rem;
    height: 4.875rem;
    background-color: ${({ theme }) => theme.colors.tfwBlack40};
    margin: ${({ theme }) => `${theme.spacing.small} 0`};
    border: ${({ isActive, theme }) => (isActive ? `2px solid ${theme.colors.tfwBlack40}` : 'none')};
    border-radius: ${({ theme }) => theme.typography.border.radius.small};
`

export const ThumbnailIcon = styled.div<{ left: boolean }>`
    display: flex;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    ${({ left }) => (left ? 'left: -8px;' : 'right: -8px;')}
`

export const StyledCarouselProvider = styled.div`
    position: relative;
    height: 100px;
    padding-left: 8px;
    li {
        list-style: none;
    }
`

export const GalleryHeaderWrapper = styled.div(
    ({ theme }) => `
    display: ${theme.style.display.flex};
    flex: 1;
    flex-direction: row;
    padding: ${theme.spacing.xSmall} 10%;
    align-items: center;
    justify-content: space-between;
    margin: 0 auto;

    @media only screen and (max-width: ${tabletBreakpoint.max}px) {
        padding: ${theme.spacing.small} 8%;
    }

    @media only screen and (max-width: ${mobileBreakpoint.max}px) {
        padding: ${theme.spacing.small};
    }
`,
)

export const GalleryFooterWrapper = styled.div`
    display: flex;
    flex: 1;
    flex-wrap: wrap;
    gap: ${({ theme }) => theme.spacing.small};
    padding: ${({ theme }) => theme.spacing.small};
    align-items: center;
    @media only screen and (min-width: ${tabletBreakpoint.max}px) {
        display: none;
    }
`

export const GalleryButtonWrapper = styled.div`
    display: none;
    flex-direction: ${({ theme }) => theme.style.flexDirection.row};
    flex-wrap: ${({ theme }) => theme.style.flexWrap.wrap};
    gap: ${({ theme }) => theme.spacing.small};
    margin-right: ${({ theme }) => theme.spacing.small};
    justify-content: ${({ theme }) => theme.style.justifyContent.flexEnd};
    align-items: ${({ theme }) => theme.style.alignItems.center};
    @media only screen and (min-width: ${tabletBreakpoint.max}px) {
        display: ${({ theme }) => theme.style.display.flex};
        flex: 1;
    }
`

export const GalleryButton = styled.div`
    display: ${({ theme }) => theme.style.display.flex};
`

export const GalleryFooterButton = styled.div`
    display: flex;
    flex: 1 1 calc(50% - ${({ theme }) => theme.spacing.small});
    min-width: 0;
`

export const StyledCloseIcon = styled(CloseIcon)`
    width: 24px;
    height: 24px;
    transition: transform 0.2s ease-in-out;
    cursor: pointer;
    &:hover {
        transform: scale(1.2);
    }
`
